module.exports = __webpack_public_path__ + "static/media/timeline1.dcfe0749.jpg";